import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';
import { InitialsPipe } from '@shared/pipes/initial/initials.pipe';
import { MatMenuModule } from '@angular/material/menu';
import { ProfileInfoComponent } from '@core/components/header/profile-info/profile-info.component';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { authActions } from '@store/actions/auth.actions';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ac-profile-trigger',
  standalone: true,
  imports: [InitialsPipe, MatMenuModule, ProfileInfoComponent, IconComponent, AsyncPipe],
  templateUrl: './profile-trigger.component.html',
  styleUrl: './profile-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileTriggerComponent {
  protected readonly _userSig = this._store.selectSignal(userSelectors.authUser);
  protected readonly _isAuthenticated$ = this._oidcSecurity.isAuthenticated$.pipe(
    map((authResult) => authResult.allConfigsAuthenticated.some((value) => value))
  );
  constructor(
    private readonly _store: Store<StoreState>,
    private readonly _oidcSecurity: OidcSecurityService
  ) {}
  protected _logout(): void {
    this._store.dispatch(authActions.attemptLogout({}));
  }
}
